module.exports = __webpack_public_path__ + "static/media/img25.266bf7da.JPG";